const pushWindow = options => {
  try {
    GaodunJSBridge.call({
      handlerName: 'pushWindow',
      ...options
    });
  } catch (e) {}
};
export default pushWindow;